<script setup lang="ts">
import { computed, defineAsyncComponent } from 'vue';
import { useGetters } from '@/composables/useVuexHelpers';

const PrimeDataTable = defineAsyncComponent(() => import('@/components/table/PrimeDataTable.vue'));

interface TableRow {
  _id: string;
  name: string;
  role: string;
}

interface Props {
  loadDataFunction?: (params: unknown) => Promise<unknown>;
}

defineProps<Props>();

const pageSize = 10;

const { tableToggleData } = useGetters(['tableToggleData']);

const tableConfig = computed(() => [
  {
    column: 'Name',
    field: 'name',
    model: (row: TableRow) => row.name,
    link: (row: TableRow) => `/organization/${row._id}`,
    sortable: true,
    index: 1,
  },
  {
    column: 'Role',
    field: 'role',
    model: (row: TableRow) => row.role,
    link: (row: TableRow) => `/organization/${row._id}`,
    filter: {
      type: 'select',
      options: ['Admin', 'Member'],
    },
    index: 2,
    sortable: true,
  },
]);

const tableOptions = computed(() => ({
  globalFilterFields: ['name'],
  tableName: 'tableUserOrganizations',
}));
</script>

<template>
  <div>
    <PrimeDataTable
      ref="dataTable"
      :tableConfig="tableConfig"
      :tableOptions="tableOptions"
      :page-size="pageSize"
      :loadDataFunction="loadDataFunction"
      @selectedColumns="tableToggleData"
    />
  </div>
</template>

<style lang="scss" scoped></style>
